import styled from "@emotion/styled";

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: initial;

`

export const FoodTypeTitle = styled.h2`
font-size: 30px;
font-weight: bold;
line-height: 1.23;
letter-spacing: -0.72px;
color: #011627;
padding-top: 80px;
`

export const FlexDisplay = styled.div`
display: flex;
flex-direction: row;
`